module.exports = __webpack_public_path__ + "static/media/delivery-of-the-keys.784b4228.jpg";